// Icon set for the redesign, backed by lucide-react.
// Keeps the design's `I.Name` API: 20px default, 1.8 stroke, currentColor.
import React from 'react';
import {
  Home,
  BookOpen,
  Bell,
  Search,
  Calendar,
  Trophy,
  BarChart3,
  LogOut,
  User,
  Settings,
  Menu,
  X,
  Check,
  Plus,
  ArrowRight,
  ArrowLeft,
  Play,
  Clock,
  Flag,
  Star,
  Flame,
  FileText,
  Video,
  Pencil,
  Trash2,
  Download,
  Eye,
  EyeOff,
  Filter,
  Mail,
  Phone,
  Sparkles,
  Atom,
  Dna,
  FlaskConical,
  RefreshCw,
  Send,
  ChevronDown,
  ChevronRight,
  MoreHorizontal,
  Lock,
  AlertTriangle,
  ShieldCheck,
  Users,
  Layers,
} from 'lucide-react';

const wrap = (Lucide) => {
  const IconComponent = ({ size = 20, strokeWidth = 1.8, className = '' }) => (
    <Lucide size={size} strokeWidth={strokeWidth} className={className} aria-hidden="true" />
  );
  return IconComponent;
};

export const I = {
  Home: wrap(Home),
  Book: wrap(BookOpen),
  Bell: wrap(Bell),
  Search: wrap(Search),
  Calendar: wrap(Calendar),
  Trophy: wrap(Trophy),
  Chart: wrap(BarChart3),
  Logout: wrap(LogOut),
  User: wrap(User),
  Settings: wrap(Settings),
  Menu: wrap(Menu),
  Close: wrap(X),
  Check: wrap(Check),
  Plus: wrap(Plus),
  ArrowR: wrap(ArrowRight),
  ArrowL: wrap(ArrowLeft),
  Play: wrap(Play),
  Clock: wrap(Clock),
  Flag: wrap(Flag),
  Star: wrap(Star),
  Fire: wrap(Flame),
  Pdf: wrap(FileText),
  Video: wrap(Video),
  Edit: wrap(Pencil),
  Trash: wrap(Trash2),
  Download: wrap(Download),
  Eye: wrap(Eye),
  EyeOff: wrap(EyeOff),
  Filter: wrap(Filter),
  Mail: wrap(Mail),
  Phone: wrap(Phone),
  Sparkle: wrap(Sparkles),
  Atom: wrap(Atom),
  Dna: wrap(Dna),
  Beaker: wrap(FlaskConical),
  Refresh: wrap(RefreshCw),
  Send: wrap(Send),
  ChevronDown: wrap(ChevronDown),
  ChevronRight: wrap(ChevronRight),
  More: wrap(MoreHorizontal),
  Lock: wrap(Lock),
  Alert: wrap(AlertTriangle),
  // Super-admin surface: the shield marks what only the DOK can reach.
  Shield: wrap(ShieldCheck),
  Users: wrap(Users),
  Layers: wrap(Layers),
};

export default I;
